export type GuestApplyPhase = 'form' | 'otp' | 'success';

/**
 * Whether the guest apply modal should auto-submit a campaign application because
 * the user became signed in while the signup form was visible (not during OTP or success).
 */
export function shouldAutoApplyGuestOnSignIn({
    isSignedIn,
    guestApplyOpen,
    guestPhase,
    pendingApplyCampaignId,
    campaignId,
}: {
    isSignedIn: boolean;
    guestApplyOpen: boolean;
    guestPhase: GuestApplyPhase;
    pendingApplyCampaignId: string | null;
    campaignId?: string;
}): boolean {
    if (!isSignedIn || !guestApplyOpen || !campaignId || guestPhase !== 'form') return false;
    if (pendingApplyCampaignId && pendingApplyCampaignId === campaignId) return false;
    return true;
}

/** Parse influencer `_id` from create-profile API responses (handles nested shapes). */
export function parseInfluencerIdFromCreateResponse(response: unknown): string | undefined {
    const influencer = parseInfluencerFromPatchResponse(response);
    return typeof influencer?._id === 'string' ? influencer._id : undefined;
}

/** Parse influencer document from PATCH /influencers/:id responses (`data.data` or flat `data`). */
export function parseInfluencerFromPatchResponse(response: unknown): Record<string, unknown> | null {
    const top = (response as { data?: unknown })?.data ?? response;
    if (!top || typeof top !== 'object') return null;
    const record = top as { _id?: string; data?: Record<string, unknown> };
    if (typeof record._id === 'string') return record as Record<string, unknown>;
    if (record.data && typeof record.data === 'object' && typeof record.data._id === 'string') {
        return record.data;
    }
    return null;
}
